import {
  CLEAR_STATE,
  SET_DOOR,
  SET_EVENT,
  SET_PANIER, SET_PANIER_REFERENCE,
  SET_PRODUCT_TO_SHOW,
  SET_SELECTED_CARD,
  SET_SELECTED_PDV,
  SET_STADIUM, SET_TIME_CREATION_PANIER,
  SET_USER,
} from '../actions/types';
import {StateModel} from "../../Models/StateModel";

export default (state: any, action: { type: any; snapshot: any; }): StateModel => {
  switch (action.type) {
    case CLEAR_STATE:
      return {
        ...state,
        stadium: undefined,
        panier: undefined,
        door: undefined,
        event: undefined,
        selectedPdv: undefined,
        productToShow: undefined,
        selectedCard: undefined
      };
    case SET_USER:
      return {
        ...state,
        user: action.snapshot,
      };
    case SET_STADIUM:
      return {
        ...state,
        stadium: action.snapshot,
      };
    case SET_DOOR:
      return {
        ...state,
        door: action.snapshot,
      };
    case SET_PANIER:
      return {
        ...state,
        panier: action.snapshot,
      };
    case SET_PANIER_REFERENCE:
      return {
        ...state,
        panier: {...state.panier, reference: action.snapshot},
      };
    case SET_PRODUCT_TO_SHOW:
      return {
        ...state,
        productToShow: action.snapshot,
      };
    case SET_SELECTED_PDV:
      return {
        ...state,
        selectedPdv: action.snapshot,
      };
    case SET_EVENT:
      return {
        ...state,
        event: action.snapshot,
      };
    case SET_SELECTED_CARD:
      return {
        ...state,
        selectedCard: action.snapshot,
      };
    case SET_TIME_CREATION_PANIER:
      return {
        ...state,
        timeCreationPanier: action.snapshot,
      };
    default:
      return state;
  }
};
